var app = angular.module('leonardo');

let NoteService = function(BaseRestService) {
  return new BaseRestService('notes', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('notes', false, function(element) {
      element.attachmentObjects = [];
      if (element.attachments && (element.attachments.length > 0)) {
        element.attachmentObjects = element.attachments;
      }
      return element;
    });
  });
};

app.factory('NoteService', ['BaseRestService', NoteService]);
